export const patientConstant = {
    GET_PATIENTS_SUCCESS: 'USER_GET_PATIENTS_SUCCESS',
    GET_PATIENT_SUCCESS: 'USER_GET_PATIENT_SUCCESS',
    SET_PAGE: 'USER_SET_PAGE',
    SET_ROWS: 'USER_SET_ROWS',
    SELECT_PATIENT: 'USER_SELECT_PATIENT'
};
